module.exports = __webpack_public_path__ + "img/timeoff-empty-image.cc3cc66d.webp";